<template>
 <div>
  <v-system-bar
    ref="topBar"
    app
    class="w-100 top-nav-bar"
    :class="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 'pr-8' : 'pr-16'"
    style="background: linear-gradient(90deg, #0a2626 0%, #061a1a 50%, #021a1a 100%) !important; height: var(--ds-nav-top-bar-height)">
    <div ref="breadcrumb" class="top-bar-breadcrumb-wrapper">
      <top-bar-breadcrumb v-if="user" :user="user" />
    </div>

    <v-spacer></v-spacer>

    <!-- Pinned Quick Settings Bar (only rendered when there is enough space in top bar) -->
    <div
      v-if="isQuickSettingsPinned && isQuickSettingsVisible && isInsideFacility && canPinToTopBar"
      class="top-bar-quick-settings-wrapper"
    >
      <QuickSettingsFloating
        :pinned="true"
        @close="handleQuickSettingsClose"
      />
    </div>

    <v-spacer></v-spacer>

    <div ref="trailingActions" class="top-bar-trailing-actions">
    <v-chip color="orange" outlined v-if="isImpersonateMode">
      <span style="color: var(--v-bg_force_white-base)">
        <i style="color:#ff9800" class="fa-solid fa-triangle-exclamation mr-2"></i>
        <span>You are in impersonation mode</span>
        <v-btn x-small text color="orange" @click="exitImpersonateMode()">Exit</v-btn>
      </span>
    </v-chip>

    <v-btn @click="toggleHelp" class="transparent-btn" text depressed :ripple="false" height="20" style="color: var(--v-bg_force_white-base)">
      <v-icon color="bg_force_white">mdi-help-circle-outline</v-icon>
      <span class="ms-1">Help</span>
    </v-btn>

    <v-btn @click="openChat"
          v-if="config.askAva == 'enabled'"
          class="transparent-btn"
          text
          depressed
          :ripple="false"
          height="20"
    ><img class="mr-1" src="/img/bot-white.png" alt="" style="height: 20px;"> Ask AVA</v-btn>
    <v-menu bottom left v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon color="bg_force_white">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(action, i) in actions"
          :key="i"
          @click="handleActionClick(action)"
          style="cursor: pointer">
          <v-list-item-title v-if="action.name === 'Notifications'">
            <v-icon class="pe-2">{{ action.icon }}</v-icon>
            {{ action.name }}
          </v-list-item-title>
          <v-list-item-title v-else>
            <v-icon class="pe-2">{{ action.icon }}</v-icon>
            {{ action.name }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item class="d-flex justify-center">
          <div v-if="false" class="d-flex align-center justify-center w-100">
            <span class="me-4" style="color: var(--v-bg_force_white-base)"
              ><strong>Dark Mode</strong></span
            >
            <v-switch
              :ripple="false"
              color="primary"
              v-model="isDarkMode"
              inset
              dense
              @click="onToggleDarkTheme"></v-switch>
          </div>
        </v-list-item>
      </v-list>
    </v-menu>
    <div v-else class="d-flex justify-end">
      <div v-for="(action, i) in actions" :key="i">
        <v-btn
          class="transparent-btn"
          text
          depressed
          :ripple="false"
          height="20"
          @click="handleActionClick(action)"
          v-if="action.name !== 'Notifications'">
          <v-icon class="pe-2" color="bg_force_white">{{ action.icon }}</v-icon>
          {{ action.name }}
        </v-btn>

        <v-menu
          offset-y
          bottom
          right
          v-else
          @input="handleMenuClose"
          :close-on-content-click="false"
          :nudge-bottom="10"
          class="pb-3">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="transparent-btn bordered_x_r_axis"
              v-bind="attrs"
              v-on="on"
              text
              depressed
              height="20">
              <v-badge
                class="customBadge"
                v-if="hasNewNotifications"
                color="pink"
                dot
                offset-y="9"
                offset-x="15"
                transition="scale-transition">
                <v-icon class="pe-2" color="bg_force_white">{{ action.icon }}</v-icon>
              </v-badge>
              <v-icon v-else class="pe-2" color="bg_force_white">{{ action.icon }}</v-icon>

              {{ action.name }}
            </v-btn>
          </template>
          <!-- write here menu content -->
          <system-notifications :isMenuClosed="menuClosed"></system-notifications>
        </v-menu>
      </div>
    </div>
    <span
      class="ms-16 me-4"
      v-if="$vuetify.breakpoint.width > 600 && false"
      style="color: var(--v-bg_force_white-base)"
      ><strong>Dark Mode</strong></span
    >
    <v-switch
      :ripple="false"
      v-if="$vuetify.breakpoint.width > 600 && false"
      color="primary"
      v-model="isDarkMode"
      inset
      dense
      dark></v-switch>
    </div>
  </v-system-bar>
  <chatbot-modal v-if="!isAssistantClient" ref="chatbot"></chatbot-modal>
 </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ChatbotModal from '@/features/Chatbot/components/chatbot-modal.vue';
  import SystemNotifications from '@Share/components/SystemNotifications.vue';
  import config from '@/../appConfig';
  import TopBarBreadcrumb from '@Share/components/breadcrumb/TopBarBreadcrumb.vue';
  import { isAnyViewerOpen } from '@/scripts/js/forgeviewer';
  import { QuickSettingsFloating } from '@Share/components/QuickSettings';
  import { canFitPinnedQuickSettings } from './QuickSettings/topBarCapacity';

  export default {
    name: 'TopNavigationBar',
    components: { ChatbotModal, SystemNotifications, TopBarBreadcrumb, QuickSettingsFloating },
    data() {
      return {
        actions: [],
        menuClosed: false,
        config,
      };
    },
    computed: {
      /** New AVA Assistant (src/features/Assistant) instead of the legacy Ask AVA modal. */
      isAssistantClient() {
        return config.assistantClient === 'enabled';
      },
      ...mapGetters('ACCOUNT', {
        user: 'GET_USER',
      }),
      userName: {
        get() {
          const userString = localStorage.getItem('R-user');

          if (userString) {
            const user = JSON.parse(userString);
            const userName = `${user.firstName} ${user.lastName}`;
            return userName;
          } else {
            return '';
          }
        },
      },
      isImpersonateMode(){
        return this.$store.getters['ACCOUNT/IS_IMPERSONATE_MODE'];
      },
      isDarkMode: {
        get() {
          return this.$store.getters['SETTING/GET_DARK_MODE'];
        },
        set(val) {
          this.$vuetify.theme.dark = val;
          return this.$store.commit('SET_DARK_MODE', val);
        },
      },
      hasNewNotifications: {
        get() {
          return this.$store.getters['NOTIFICATIONS/GET_HAS_NEW_NOTIFICATION'];
        },
      },
      userNotifications() {
        return this.$store.getters['NOTIFICATIONS/GET_USER_NOTIFICATIONS'];
      },
      isViewerOpen() {
        return isAnyViewerOpen();
      },
      isQuickSettingsPinned() {
        return this.$store.getters['GENERAL/GET_IS_QUICK_SETTINGS_PINNED'];
      },
      isQuickSettingsVisible() {
        return this.$store.getters['GENERAL/GET_IS_QUICK_SETTINGS_VISIBLE'];
      },
      isInsideFacility() {
        return this.$route.matched.some(
          (record) => record.meta && record.meta.facilityScope
        );
      },
      canPinToTopBar() {
        return this.$store.getters['GENERAL/GET_CAN_PIN_QUICK_SETTINGS_TO_TOP_BAR'];
      },
    },
    methods: {
      measureTopBarCapacity() {
        const bar = this.$refs.topBar.$el;
        const style = window.getComputedStyle(bar);
        const canPin = canFitPinnedQuickSettings({
          viewportWidth: window.innerWidth,
          innerWidth: bar.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight),
          breadcrumbWidth: this.$refs.breadcrumb.getBoundingClientRect().width,
          actionsWidth: this.$refs.trailingActions.getBoundingClientRect().width,
        });
        if (canPin !== this.canPinToTopBar) {
          this.$store.commit('GENERAL/SET_CAN_PIN_QUICK_SETTINGS_TO_TOP_BAR', canPin);
        }
      },
      scheduleTopBarMeasurement() {
        if (this.topBarMeasurementFrame) return;
        this.topBarMeasurementFrame = window.requestAnimationFrame(() => {
          this.topBarMeasurementFrame = null;
          this.measureTopBarCapacity();
        });
      },
      openChat(){
        if (this.isAssistantClient) {
          this.$store.dispatch('ASSISTANT/TOGGLE');
          return;
        }
        this.$refs.chatbot.open();
      },
      toggleHelp() {
        if (window.FreshworksWidget && typeof window.FreshworksWidget === 'function') {
          window.FreshworksWidget('open');
        }
      },
      exitImpersonateMode(){
        this.$dialog.warning({
            text: `Are you sure you want to exit impersonate mode?`,
            title: 'Exit impersonate mode',
            actions: {
              false: 'Cancel',
              true: {
                text: 'Ok',
                color: 'primary',
                handle: () => {
                  this.$store.dispatch('COMPANY/EXIT_IMPERSONATION').then(()=>{
          location.href='/';
        });

                },
              },
            },
          });


      },
      onToggleDarkTheme(event) {
        event.stopPropagation();
      },
      handleMenuClose(isOpen) {
        this.menuClosed = isOpen ? false : true;
      },
      handleActionClick(action) {
        if (action.name === 'My Account' && this.isViewerOpen) {
          this.$dialog.warning({
            text: 'You have a viewer open. Navigating away will close it. Are you sure you want to continue?',
            title: 'Close Viewer',
            actions: {
              false: 'Cancel',
              true: {
                text: 'Continue',
                color: 'primary',
                handle: () => {
                  this.$router.push(action.link);
                },
              },
            },
          });
        } else {
          this.$router.push(action.link);
        }
      },
      handleQuickSettingsClose() {
        this.$store.commit('GENERAL/SET_QUICK_SETTINGS_VISIBLE', false);
      },
    },
    created() {
      this.actions = [
        {
          name: 'Notifications',
          icon: 'mdi-bell',
          link: ``,
        },
        {
          name: this.userName,
          icon: 'mdi-account-circle',
          link: `/users/${this.user.id}`,
        },
      ];
      this.$store.dispatch('NOTIFICATIONS/GET_USER_NOTIFICATIONS');
    },
    mounted() {
      this.topBarResizeObserver = new ResizeObserver(this.scheduleTopBarMeasurement);
      [this.$refs.topBar.$el, this.$refs.breadcrumb, this.$refs.trailingActions]
        .forEach(element => this.topBarResizeObserver.observe(element));
      this.scheduleTopBarMeasurement();
    },
    beforeDestroy() {
      this.topBarResizeObserver.disconnect();
      window.cancelAnimationFrame(this.topBarMeasurementFrame);
      this.$store.commit('GENERAL/SET_CAN_PIN_QUICK_SETTINGS_TO_TOP_BAR', false);
    },
    watch: {
      userNotifications: {
        handler() {
          this.$store.commit(
            'NOTIFICATIONS/SET_HAS_NEW_NOTIFICATION',
            this.userNotifications.some((item) => item.read === false),
          );
        },
        deep: true,
      },
    },
  };
</script>
<style lang="scss" scoped>
  /* Override Vuetify v-system-bar's default left padding so the breadcrumb
     logo slot aligns flush with the left edge (and by extension, the side
     rail below it). The right padding is preserved via the :class binding. */
  .top-nav-bar.v-system-bar {
    padding-left: 0 !important;
    z-index: 150 !important;
    overflow: visible !important;
  }

  .top-bar-quick-settings-wrapper {
    display: flex;
    align-items: center;
    margin: 0 16px;
    flex-shrink: 0;
    height: 100%;
  }

  .top-bar-breadcrumb-wrapper,
  .top-bar-trailing-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .bordered_x_r_axis {
    border-right: 1px solid;
    border-radius: 0px;
  }
  .transparent-btn {
    background-color: transparent;
    color: var(--v-bg_force_white-base); /* Make the text white */

    &:hover::before,
    &:focus::before,
    &:active::before {
      background-color: transparent;
    }

    &:focus,
    &:active {
      background-color: transparent;
    }
    &::before {
      background-color: transparent;
    }
  }
</style>
